// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_v8-8";
export var editMode = "_v8-3";
export var headerRow = "_v8-a";
export var headerTitle = "_v8-b";
export var product = "_v8-1";
export var productDetails = "_v8-5";
export var productDivider = "_v8-7";
export var productImage = "_v8-2";
export var productInfo = "_v8-4";
export var productTitle = "_v8-6";
export var strikethrough = "_v8-9";
export var upsellProductsCard = "_v8-0";